import APIService from '@/services/APIService.js';

export default {
  getAllGruposArquivos() {
    return APIService.apiCall().get(`/gruposArquivos/getAllGruposArquivos`);
  },
  getGruposArquivosAtivos() {
    return APIService.apiCall().get(`/gruposArquivos/getGruposArquivosAtivos`);
  },
  getGrupoArquivos(id) {
    return APIService.apiCall().get(`/gruposArquivos/getGrupoArquivos/${id}`);
  },
  salvarGrupoArquivos(id, postData) {
    return APIService.apiCall().post(`/gruposArquivos/salvar/${id}`, JSON.stringify(postData));
  },
  atualizarStatus(id) {
    return APIService.apiCall().get(`/gruposArquivos/atualizarStatus/${id}`);
  },
  getAnoMesGrupoWithFiles() {
    return APIService.apiCall().get(`/gruposArquivos/getAnoMesGrupoWithFiles`);
  }
};
